// extracted by mini-css-extract-plugin
module.exports = {"entryTextContainer":"style-module__entryTextContainer___2DlQD","textEntryLabels":"style-module__textEntryLabels___yVPSk"};